import signalR from '../libs/signalR'
import $ from 'jquery'
import localStorageManager from '@/utils/localStorageManager'
signalR($)

const SignalRPlugin = {}
SignalRPlugin.install = function(Vue, connectionUrl) {
  if (!connectionUrl) {
    throw new Error('Connection url not provided')
  }
  Vue.prototype.$signalRConnected = false
  let signalRConnection
  let signalRHubProxy

  Vue.prototype.$configureSignalR = () => {
    signalRConnection = $.hubConnection(connectionUrl)
    signalRHubProxy = signalRConnection.createHubProxy('sidHub')

    Vue.prototype.$signalRConnection = signalRConnection
    Vue.prototype.$signalRHubProxy = signalRHubProxy
  }

  Vue.prototype.$connectSignalR = async (transactionId, system) => {
    const jwtIdentity = localStorageManager.getToken(transactionId)
    const token = jwtIdentity?.token
    signalRConnection.qs = {
      jwtIdentity: token,
      transactionId,
      system,
    }
    return signalRConnection.start()
  }

  Vue.prototype.$stopSignalR = async () => {
    return signalRConnection.stop()
  }
}

export default SignalRPlugin
